import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Styles from './Column.module.scss';

const Action = React.memo(({ className, children, ...props }) => {
  return (
    <div className={classNames(Styles.action, className)} {...props}>
      {children}
    </div>
  );
});

Action.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

Action.defaultProps = {
  className: '',
};

export default Action;
